import { Input } from "antd";
import React from "react";
import "./InputPassword.css";
function InputPassword(props) {
  const { userDetail, setUserDetail, onClickEnter } = props;
  const { wrongList, setWrongList } = props;
  return (
    <div className="input-password">
      <Input.Password
        placeholder={"Password"}
        onPressEnter={(e) =>{
            setUserDetail({ ...userDetail, password: e.target.value })
            onClickEnter()
          }
        }
        value={userDetail.password === undefined ? "" : userDetail.password}
        onChange={(e) =>
          setUserDetail({ ...userDetail, password: e.target.value })
        }
        className={
          wrongList.includes("password") === true
            ? "phone-input-password-wrong"
            : "phone-input-password-correct"
        }
      />
    </div>
  );
}

export default InputPassword;
